//import { apiUrl as api_url } from "../utils/helpers/enviroment.helpers";
import { fetchWithCredentials, handleErrorsStatus } from "./httpService";

const api_path = "familiares/";

export const getFamiliar = async (dniTitular) => {
  try {
    const respuesta = await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path + dniTitular,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await handleErrorsStatus(respuesta);
    // return [
    //     { dni: 39001455, nombreCompleto: "Magallanes, Matías"},
    //     { dni: 30456321, nombreCompleto: "Magallanes, Juan Manuel"},
    //     { dni: 42005439, nombreCompleto: "Flores, Alejandra"}
    // ];
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al buscar a los familiares.");
  }
};